import {
  PLAY_COUPON_SUCCESS,
  POST_REGISTER_SUCCESS,
} from 'Store/constants';

export const taboolaPixelListener = () => {
  return next => action => {
    const returnValue = next(action);

    const utmSource = sessionStorage.getItem('utm_source');
    if (utmSource !== 'taboola' || !window._tfa)
      return returnValue;


    if (action.type === POST_REGISTER_SUCCESS) {
      window._tfa.push({ notify: 'event', name: 'lead', id: 1340277 });
    }

    if (action.type === PLAY_COUPON_SUCCESS) {
      const { coupon } = action.payload;

      window._tfa.push({ notify: 'event', name: 'make_purchase', id: 1340277, revenue: coupon.couponCost, currency: 'TRY' });
    }

    return returnValue;
  };
};
